import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Field, Input } from '../../../components/ui/Field.jsx'
import { useFeedback } from '../../../components/ui/feedback.jsx'
import api from '../../../lib/api.js'
import { isValidVat, cleanVat } from '../../../lib/validation.js'

/* Step 6 — first customer (skippable). POST /customers/ when filled. */
export default function StepCustomer({ bindSubmit }) {
  const { t } = useTranslation()
  const { notify } = useFeedback()
  const [f, setF] = useState({ name: '', vat_number: '', non_vat_liable: false, email: '', city: '', payment_terms_days: '' })
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }))

  useEffect(() => {
    bindSubmit(async () => {
      if (!f.name.trim()) return true // skip if empty
      if (f.vat_number && !isValidVat(f.vat_number)) { notify({ tone: 'error', title: t('setup.error'), message: t('parties.fields.vatInvalid') }); return false }
      try {
        await api.post('/customers/', { ...f, vat_number: cleanVat(f.vat_number), payment_terms_days: f.payment_terms_days ? Number(f.payment_terms_days) : undefined })
        return true
      } catch (e) { notify({ tone: 'error', title: t('setup.error'), message: e?.response?.data?.error || t('settings.errorGeneric') }); return false }
    })
  }, [f, bindSubmit, notify, t])

  return (
    <>
      <p style={{ color: 'var(--color-text)', fontSize: 14, marginBottom: 16 }}>{t('setup.steps.customer.intro')}</p>
      <Field label={t('parties.fields.name')}><Input value={f.name} onChange={(e) => set('name', e.target.value)} /></Field>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
        <Field label={t('parties.fields.vatNumber')}><Input value={f.vat_number} onChange={(e) => set('vat_number', e.target.value)} placeholder="BE0123456789" /></Field>
        <Field label="Email"><Input type="email" value={f.email} onChange={(e) => set('email', e.target.value)} /></Field>
        <Field label={t('parties.fields.city')}><Input value={f.city} onChange={(e) => set('city', e.target.value)} /></Field>
        <Field label={t('parties.fields.paymentTermsDays')}><Input type="number" min="0" value={f.payment_terms_days} onChange={(e) => set('payment_terms_days', e.target.value)} /></Field>
      </div>
    </>
  )
}
